import { render, staticRenderFns } from "./StrategyLaunchPage.vue?vue&type=template&id=053c375b"
import script from "./StrategyLaunchPage.vue?vue&type=script&lang=ts"
export * from "./StrategyLaunchPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports